import { bhMonitor } from '../../cred';
import { getMobileOperatingSystem, getBrowserNVersion } from '../../customLib';

export const initialMonitorState = {
	sendingFromMonitor: false,
	monitorEvents: [],
	monitorTimeout: null,
};

const sendToMonitor = async ({ monitorEvents, referralID }) => {
	try {
		const { status } = await bhMonitor(
			JSON.stringify({
				events: monitorEvents,
				user_id: !!referralID ? referralID : -1,
				event_id: 100000,
				event_type: 100000,
				client_id: 'BITBNS_WEB',
			})
		);

		if (status === 1) {
			return {
				sendingFromMonitor: false,
			};
		}
	} catch (error) {
		console.log('sendEvent', error);
	}
	return {};
};

// ----------------------------------------------------------

export const monitorActions = {
	/**
	 * Monitor Functions
	 */
	__sendToMonitor: sendToMonitor,
	__setMonitorTimeout: (_, monitorTimeout) => ({
		monitorTimeout,
	}),
	__pushToMonitorEvents: (
		{ monitorEvents, urlLocation },
		event_name,
		properties = {}
	) => {
		const newMonitorEvents = monitorEvents.slice();

		const newEvent = {
			event_name,

			properties: {
				...properties,
				urlLocation: `https://bitbns.com/trade/#${urlLocation}`,
				device: !getMobileOperatingSystem() ? 'Deski' : 'Mob',
				browser: getBrowserNVersion(),
			},

			time: (Date.now() / 1000) | 0,
		};

		newMonitorEvents.push(newEvent);

		return {
			monitorEvents: newMonitorEvents,
		};
	},
	__sendingFromMonitor: () => ({
		sendingFromMonitor: true,
		monitorEvents: [],
		monitorTimeout: null,
	}),
};
